<template>
  <!--<div class="main-box">-->

  <div class="bottom-tap">
    <router-link tag="div" to="/main/index" exact>
      <span class="bot-tag-icon bot-index"></span>
      <span class="bot-tag-txt">{{ $t("index.Home") }}</span>
    </router-link>

    <router-link tag="div" to="/main/user">
      <!--<router-link tag="div" to="/main/useragent" exact>-->
      <span class="bot-tag-icon bot-user"></span>
      <span class="bot-tag-txt">{{ $t("index.Mine") }}</span>
    </router-link>
  </div>

  <!--</div>-->
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped="" lang="less">
/*.main-box{*/
/*display:flex;*/
/*flex-direction: column;*/
/*height:100%;*/
.bottom-tap {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  // height: 0.76rem;
  height: 1.1rem;
  border-top: 0.01rem solid #ddd;
  background: #fff;
  padding: 0.12rem 0 0.14rem 0;
  z-index: 99;
  div {
    width: 50%;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    align-items: center;
    font-size: 0.2rem;
    font-weight: normal;
    &.router-link-active {
      color: #005587;
      &:after {
        content: "";
        width: 1.2rem;
        height: 0.12rem;
        background: #005587;
        border-radius: 0.06rem;
      }
      span {
        font-weight: bold;
        &.bot-tag-icon {
          width: 0.5rem;
          height: 0.5rem;
          &.bot-index {
            background: url("~@/assets/img/index_iconc.png") no-repeat
              center/contain;
          }
          &.bot-user {
            background: url("~@/assets/img/user_iconc.png") no-repeat
              center/contain;
          }
        }
      }
    }
    span {
      display: block;
      &.bot-tag-txt {
        font-size: 0.22rem;
      }
      &.bot-tag-icon {
        width: 0.5rem;
        height: 0.5rem;
        &.bot-index {
          background: url("~@/assets/img/index_icon.png") no-repeat
            center/contain;
        }
        &.bot-user {
          background: url("~@/assets/img/user_icon.png") no-repeat
            center/contain;
        }
      }
    }
  }
}
/*}*/
</style>
